import React from 'react';
import { Helmet } from 'react-helmet-async';
import { TEXTS } from '@/constants/texts';

// ========================================
// PRIVACY POLICY PAGE
// ========================================

export const PolitiqueConfidentialite: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <>
            <Helmet>
                <title>Privacy Policy - {TEXTS.landing.title}</title>
                <meta name="description" content="Privacy Policy of Get My News" />
            </Helmet>

            <div className="legal-page">
                <div className="legal-page__container">
                    <header className="legal-page__header">
                        <a href="/" className="legal-page__back-link">
                            ← Back
                        </a>
                        <h1 className="legal-page__title">Privacy Policy</h1>
                    </header>

                    <main className="legal-page__content">
                        <section className="legal-page__section">
                            <h2>Introduction</h2>
                            <p>
                                Get My News is committed to protecting your privacy. This policy explains
                                how we collect and use your personal data.
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Data Collected</h2>
                            <p>
                                Currently, we only collect your email address when you sign up
                                to be notified of the launch of Get My News.
                            </p>
                            <p><strong>We collect:</strong></p>
                            <ul>
                                <li>Your email address</li>
                                <li>Registration date</li>
                            </ul>
                        </section>

                        <section className="legal-page__section">
                            <h2>Data Usage</h2>
                            <p>
                                Your email address is used only to:
                            </p>
                            <ul>
                                <li>Notify you of the Get My News launch</li>
                                <li>Send you important information about the service</li>
                            </ul>
                            <p>
                                <strong>We don't spam.</strong> You will receive a single email at launch,
                                unless you choose to subscribe to our newsletter.
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Data Retention</h2>
                            <p>
                                Your data is retained until the service launch. You can request
                                deletion at any time by contacting us at: contact@get-my-news.com
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Data Sharing</h2>
                            <p>
                                We do not sell, rent, or share your personal data with
                                third parties, except when legally required.
                            </p>
                            <p>
                                Our data is hosted by Buttondown (newsletter service) and Netlify
                                (web hosting), both GDPR-compliant.
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Your Rights (GDPR)</h2>
                            <p>Under GDPR, you have the following rights:</p>
                            <ul>
                                <li><strong>Right of access:</strong> Request a copy of your data</li>
                                <li><strong>Right to rectification:</strong> Correct your data</li>
                                <li><strong>Right to erasure:</strong> Delete your data</li>
                                <li><strong>Right to object:</strong> Object to data processing</li>
                                <li><strong>Right to withdraw consent:</strong> Withdraw your consent at any time</li>
                            </ul>
                            <p>
                                To exercise these rights, contact us at: contact@get-my-news.com
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Cookies and Analytics</h2>
                            <p>
                                This site may use analytics cookies (Google Analytics, Plausible, or similar)
                                to understand traffic. These tools are configured to respect your privacy.
                            </p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Changes to This Policy</h2>
                            <p>
                                We reserve the right to modify this policy. Any changes
                                will be posted on this page.
                            </p>
                            <p><em>Last updated: {currentYear}</em></p>
                        </section>

                        <section className="legal-page__section">
                            <h2>Contact</h2>
                            <p>
                                For any questions regarding this privacy policy,
                                contact us at: <a href="mailto:contact@get-my-news.com">contact@get-my-news.com</a>
                            </p>
                        </section>
                    </main>

                    <footer className="legal-page__footer">
                        <p>© {currentYear} {TEXTS.landing.title}</p>
                    </footer>
                </div>
            </div>
        </>
    );
};

PolitiqueConfidentialite.displayName = 'PolitiqueConfidentialite';

export default PolitiqueConfidentialite;
